<template>
  <main class="form-signin">
    <form>
      <img class="mb-4" src="../assets/img/logo.png" alt="Logo" width="200" height="110" />

      <div class="input-group mb-3">
        <span class="input-group-text"><i class="fas fa-at "></i></span>
        <input class="form-control" id="email" name="email" placeholder="Email" v-model="user.email" />
      </div>

      <div class="input-group mb-3">
        <span class="input-group-text"><i class="fas fa-lock"></i></span>
        <input class="form-control" id="password" name="password" placeholder="Password" :type="showPassword? 'text': 'password'" v-model="user.password" />
        <span class="input-group-text">
          <i :class="showPassword? 'far fa-eye-slash': 'far fa-eye'" id="togglePassword" style="cursor: pointer" @click="togglePasswordField"></i>
        </span>
      </div>
      <button class="w-100 btn btn-lg btn-primary" type="button" @click="loginUser">Login</button>
      <p class="mt-5 mb-3 text-muted">&copy; GOFAR</p>
    </form>
  </main>
</template>

<script>
const localStorageHelper = require('../helpers/local-storage');
export default {
  name: 'Login',
  data() {
    return {
      user: {
        email: '',
        password: ''
      },
      showPassword: false
    };
  },
  methods: {
    togglePasswordField (){
      this.showPassword = !this.showPassword;

    },
    async loginUser() {
      await this.$store.dispatch('loginUser', this.user);
      if (this.$store.state.loggedInUser) {
        localStorageHelper.setLoggedInUser(this.$store.state.loggedInUser);
        const role = localStorageHelper.getRole();
        if (typeof role === 'string' && role === 'admin') {
          await this.$router.push({ path: '/admin' });
        } else {
          const redirectTo = localStorage.getItem('redirectTo');
          if (redirectTo) {
            await this.$router.push({ path: redirectTo });
          } else {
            await this.$router.push({ path: '/dashboard' });
          }
        }
      } else {
        this.$notify({
          title: 'Fail!',
          text: 'Login failed! Check your credentials and try again',
          type: 'error',
          duration: 10000
        });
      }
    }
  }
};
</script>

<style scoped>
.form-signin {
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
</style>
